var image_viewer_rtlignore_default = {
  "fontElementMap": "YpgVl",
  "imageContainer": "c-jqz",
  "expandContainer": "B-T3I",
  "expandIcon": "Nry8x",
  "pointer": "vcbZe",
  "imageWrapper": "ULq8n",
  "imageRatio": "oDRe0",
  "image": "E2hd4",
  "imageOverlay": "nNMDf",
  "imagePreload": "kDsYu",
  "imageHighres": "-o2Pw",
  "onlyHighRes": "Z0uCX",
  "image_loading": "Wxm1u"
};
export {
  image_viewer_rtlignore_default as default
};
//# sourceMappingURL=image-viewer.rtlignore-scss.js.map
